var map = {
	"./Article": "tFjb",
	"./Article/": "tFjb",
	"./Article/index": "tFjb",
	"./Article/index.jsx": "tFjb",
	"./Article/styles.module.css": "eGov",
	"./FooterLayout": "kQpj",
	"./FooterLayout/": "kQpj",
	"./FooterLayout/index": "kQpj",
	"./FooterLayout/index.jsx": "kQpj",
	"./FooterLayout/styles.module.css": "C1c9",
	"./LayoutContainer": "++Gw",
	"./LayoutContainer/": "++Gw",
	"./LayoutContainer/index": "++Gw",
	"./LayoutContainer/index.jsx": "++Gw",
	"./LayoutContainer/styles.module.css": "jAT/",
	"./MenuLayout": "ujSS",
	"./MenuLayout/": "ujSS",
	"./MenuLayout/index": "ujSS",
	"./MenuLayout/index.jsx": "ujSS",
	"./MenuLayout/styles.module.css": "BsFU",
	"./QuoteLayout": "k5kR",
	"./QuoteLayout/": "k5kR",
	"./QuoteLayout/index": "k5kR",
	"./QuoteLayout/index.jsx": "k5kR",
	"./QuoteLayout/styles.module.css": "QIV0",
	"./SectionMedia": "nr4E",
	"./SectionMedia/": "nr4E",
	"./SectionMedia/index": "nr4E",
	"./SectionMedia/index.jsx": "nr4E",
	"./SectionMedia/styles.module.css": "dqFM",
	"./StoryLayout": "QAGn",
	"./StoryLayout/": "QAGn",
	"./StoryLayout/index": "QAGn",
	"./StoryLayout/index.jsx": "QAGn",
	"./StoryLayout/styles.module.css": "9y+B"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7hsL";